/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssociatedResultTemplateDTO,
    AssociatedResultTemplateDTOFromJSON,
    AssociatedResultTemplateDTOFromJSONTyped,
    AssociatedResultTemplateDTOToJSON,
} from './AssociatedResultTemplateDTO';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface CompetenceTemplateDTO
 */
export interface CompetenceTemplateDTO {
    /**
     * 
     * @type {string}
     * @memberof CompetenceTemplateDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompetenceTemplateDTO
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof CompetenceTemplateDTO
     */
    type?: LearningCompetenceTypeEnum;
    /**
     * 
     * @type {Array<AssociatedResultTemplateDTO>}
     * @memberof CompetenceTemplateDTO
     */
    associatedResultTemplates?: Array<AssociatedResultTemplateDTO> | null;
}

export function CompetenceTemplateDTOFromJSON(json: any): CompetenceTemplateDTO {
    return CompetenceTemplateDTOFromJSONTyped(json, false);
}

export function CompetenceTemplateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetenceTemplateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
        'associatedResultTemplates': !exists(json, 'associatedResultTemplates') ? undefined : (json['associatedResultTemplates'] === null ? null : (json['associatedResultTemplates'] as Array<any>).map(AssociatedResultTemplateDTOFromJSON)),
    };
}

export function CompetenceTemplateDTOToJSON(value?: CompetenceTemplateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
        'associatedResultTemplates': value.associatedResultTemplates === undefined ? undefined : (value.associatedResultTemplates === null ? null : (value.associatedResultTemplates as Array<any>).map(AssociatedResultTemplateDTOToJSON)),
    };
}

